import React from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { AssetViewComponent } from "./AssetView";

export const ConfigurationAssetComponent = () => {
	return (
		<>
			<DndProvider backend={HTML5Backend}>
				<AssetViewComponent />
			</DndProvider>
		</>
	);
};
